import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  standalone: true,
  selector: 'eiq-label-with-loader',
  templateUrl: './label-with-loader.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatProgressSpinnerModule]
})
export class LabelWithLoaderComponent {
  label = input.required<string>();
  isLoading = input<boolean>(false);
}
